import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  displaySearchText: boolean;
  isSearching: boolean;
};

export const SearchInfoText: FC<Props> = ({ displaySearchText, isSearching }) => (
  <div className={styles.container}>
    {displaySearchText && (
      <p className={styles.text}>{isSearching ? "検索中..." : "検索結果が表示されます"}</p>
    )}
  </div>
);
